import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer/index'
import { compose } from 'redux'
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router'
import { WithToast } from 'src/type/lib/withToast'
import { withToast } from 'src/shared/Toast'
import { formAction } from 'src/core/redux/action/formAction'
import { fetchEnterpriseSelected, fetchAccountInfos } from 'src/core/redux/action/accountInfosAction'
import { isObligedAnswerQP, isObligedAnswerQPV2 } from 'src/shared/FormArkea/helpers'
import Dashboard from 'src/page/Consumer/Dashboard/Dashboard'
import ChangePassword from 'src/page/ChangePassword/ChangePassword'
import Newsletter from 'src/page/Consumer/Newsletter/Newsletter'
import Enterprise from 'src/page/Consumer/Enterprise/Enterprise'
import Form from 'src/page/Consumer/Form/Form'
import FormNotAllow from 'src/page/Consumer/Form/FormNotAllow'
import News from 'src/page/Consumer/News/News'
import NewsPost from 'src/shared/News/NewsPost'
import EcoWatch from 'src/page/Consumer/EcoWatch/EcoWatch'
import Profile from 'src/page/Consumer/Profile/Profile'
import ConsumerBar from 'src/shared/ConsumerBar/ConsumerBar'
import Signature from 'src/page/Consumer/Signature/Signature'
import Products from 'src/page/Consumer/Products/Products'
import Product from 'src/page/Consumer/Product/Product'
import Cotations from 'src/page/Consumer/Cotations/Cotations'
import Cotation from 'src/page/Consumer/Cotation/Cotation'
import CotationRequest from 'src/page/Consumer/Product/cotation/CotationRequest'
import Transactions from 'src/page/Consumer/Transactions/Transactions'
import Contact from 'src/page/Consumer/Contact/Contact'
import CguValidation from 'src/page/Consumer/CGU/CguValidation'
import Kyc from 'src/page/Consumer/Kyc/Kyc'
import autobind from 'autobind-decorator'
import MarketIndicators from 'src/page/Consumer/MarketIndicators/MarketIndicators'
import ReduxModal from 'src/shared/Modal/ReduxModal'
import * as moment from 'moment'

const drawerWidth = 250;

const styles = (t: Theme) => createStyles({
  root: {
    display: 'flex',
  },
  content: {
    [t.breakpoints.down('sm')]: {
      width: '100%',
    },
    [t.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  }
})

interface IProps extends WithI18n,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}
interface IStates {
  activeSidebarItem: boolean;   // disabled menu item sidebar if user must to answer the form
  restrictionLoading: boolean;
}

class Consumer extends React.Component<IProps, IStates> {
  state = {
    activeSidebarItem: false,
    restrictionLoading: true,
  }

  render() {
    const { classes, enterprise } = this.props
    const { activeSidebarItem, restrictionLoading } = this.state

    return (
      <div className={classes.root}>
        <ConsumerBar activeSidebarItem={activeSidebarItem} />

        <main className={classes.content}>
          <div style={{ maxWidth: '100%' }}>
            {enterprise &&
              <>
                <Switch>
                  <Route exact path={this.route('/dashboard')} component={Dashboard} />
                  <Route path={this.route('/dashboard/:postId/:postName')} component={NewsPost} />
                  <Route path={this.route('/profile')} component={Profile} />
                  <Route path={this.route('/bulletin')} component={Newsletter} />
                  <Route path={this.route('/change-password')} component={ChangePassword} />
                  <Route path={this.route('/enterprise')} component={Enterprise} />
                  <Route path={this.route('/form')} component={Form} />
                  <Route path={this.route('/cgu-validation')} component={CguValidation} />
                  <Route path={this.route('/form-not-allow')} component={FormNotAllow} />
                  <Route path={this.route('/products')} component={Products} />
                  <Route path={this.route('/product-detail/:productType')} component={Product} />
                  <Route path={this.route('/cotations')} component={Cotations} />
                  <Route path={this.route('/cotation/:productType/:cotationId')} component={Cotation} />
                  <Route path={this.route('/cotation-request/:productType')} component={CotationRequest} />
                  <Route path={this.route('/cotation-duplicate/:productType/:cotationId')} component={CotationRequest} />
                  <Route exact path={this.route('/news')} component={News} />
                  <Route path={this.route('/news/:postId/:postName')} component={NewsPost} />
                  <Route exact path={this.route('/eco-watch')} component={EcoWatch} />
                  <Route path={this.route('/eco-watch/:postId/:postName')} component={NewsPost} />
                  <Route path={this.route('/signature')} component={Signature} />
                  <Route path={this.route('/operations')} component={Transactions} />
                  <Route path={this.route('/kyc')} component={Kyc} />
                  <Route path={this.route('/contact')} component={Contact} />
                  <Route path={this.route('/market-indicators')} component={MarketIndicators} />
                  {!restrictionLoading &&
                    <Redirect exact from={this.route('')} to={this.route('/dashboard')} />
                  }
                </Switch>
                <div id="client-info" style={{ position: 'absolute', height: 0, width: 0, overflow: 'hidden' }}>
                  <span id="client-name">{enterprise.name}</span>
                  <span id="commercial-antenna">{enterprise.sales_branch_name ? enterprise.sales_branch_name : '-'}</span>
                </div>
                <ReduxModal />
              </>
            }
          </div>
        </main>
      </div>
    )
  }

  componentDidMount() {
    this.props.getEnterprise()
  }

  componentDidUpdate(prevPros) {
    const { enterprise, location } = this.props
    if (
      (prevPros.location !== location && location.state && location.state.needRefesh === true) ||
      (prevPros.enterprise !== enterprise && enterprise)
    ) {
      this.restrictionConsumer();
    }
  }

  @autobind
  private restrictionConsumer() {
    const { enterprise, connectedUser } = this.props
    if ((enterprise && !enterprise.date_acceptation_cgu) ||
      (enterprise && !enterprise.validation_dematerialisation) ||
      (enterprise && enterprise.validation_dematerialisation && enterprise.validation_dematerialisation === false)) {
      this.setState({ restrictionLoading: false });
      this.props.history.push(this.route('/cgu-validation'))
    } else {
      if (enterprise && enterprise.is_pro || connectedUser.read_only_access === true) {
        this.setState({ activeSidebarItem: true })
        this.props.history.push(this.route('/dashboard'))
      } else {
        this.findWichFormToUse(enterprise && enterprise.id)
      }
    }
  }

  private route(path: string = '') {
    return this.props.match.url + path
  }

  findWichFormToUse = async (enterpriseId: string) => {
    const { getFormVersion, enterprise, fetchForm } = this.props
    const formVersionToUpdate = await getFormVersion(enterpriseId)
    const formActualVersion = enterprise && enterprise.qp_version
    if (formVersionToUpdate.version !== formActualVersion) {
      fetchForm(formActualVersion).then(res => {
        if (isObligedAnswerQP(res) || this.isFormShouldBeUpdate()) {
          this.setState({ activeSidebarItem: false })
          this.formRouting()
        } else {
          this.setState({ activeSidebarItem: true, restrictionLoading: false })
        } 
      }).catch(err => {
        this.setState({ activeSidebarItem: true, restrictionLoading: false })
      })
    } else {
      fetchForm(formVersionToUpdate.version).then(res => {
        if (isObligedAnswerQPV2(res) || this.isFormShouldBeUpdate()) {
          this.setState({ activeSidebarItem: false })
          this.formRouting()
        } else {
          this.setState({ activeSidebarItem: true, restrictionLoading: false })
        }
      }).catch(err => {
        this.setState({ activeSidebarItem: true, restrictionLoading: false })
      })
    }
  }

  isFormShouldBeUpdate(){
        const {enterprise} = this.props;
        if(enterprise !== undefined && enterprise.qp_last_updated_at !== undefined){
          const dateFormShouldBeUpdateStart = moment(enterprise.qp_last_updated_at).add(moment.duration(2, 'years').asDays(), 'd').subtract(90, 'd').format()
          const dateFormShouldBeUpdateEnd = moment(enterprise.qp_last_updated_at).add(moment.duration(2, 'years').asDays(), 'd').format()
          return moment().isBetween(dateFormShouldBeUpdateStart, dateFormShouldBeUpdateEnd) 
              || moment().isAfter(dateFormShouldBeUpdateEnd) 
              || moment().diff(moment(dateFormShouldBeUpdateEnd), 'days') === 0
        } else {
            return false;
        }
    }

  formRouting = () => {
    const enterpriseCurrent = this.props.enterprises.find(e => e.id === this.props.match!.params.key)
    if (enterpriseCurrent.is_mandataire === false && enterpriseCurrent.habilitations.length === 0) {
      this.setState({ restrictionLoading: false });
      this.props.history.push(this.route('/form-not-allow'))
    } else {
      this.setState({ restrictionLoading: false });
      this.props.history.push(this.route('/form'))  // force user to answer if form's answer is empty
    }
  }
}

const state2props = (state: RootState) => ({
  enterprises: state.accountInfo.enterprises,
  connectedUser: state.accountInfo.connectedUser,
  context: state.accountInfo.context,
  enterprise: state.accountInfo.enterpriseSelected,
  form: state.formAnswer.form
})

const dispatch2props = (dispatch: any, ownProps: any) => ({
  fetchInfos: () => dispatch(fetchAccountInfos()),
  fetchForm: (version: number) => dispatch(formAction.fetchForm(ownProps!.match!.params.key, version)),
  getFormVersion: (enterpriseId: string) => dispatch(formAction.getQPversion(enterpriseId)),
  getEnterprise: () => dispatch(fetchEnterpriseSelected(ownProps!.match!.params.key))
})

export default compose(
  withI18n,
  withStyles(styles),
  withRouter,
  withToast,
  connect(state2props, dispatch2props),
)(Consumer)



// WEBPACK FOOTER //
// ./src/page/Consumer/Consumer.tsx